export default "__VITE_ASSET__B73g8oPL__"